declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>;
    Tawk_LoadStart?: Date;
  }
}

let initialized = false;

export function initTawkTo(): void {
  const propertyId = import.meta.env.VITE_TAWKTO_PROPERTY_ID;
  const widgetId = import.meta.env.VITE_TAWKTO_WIDGET_ID;
  if (!propertyId || !widgetId || initialized) return;

  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
  script.charset = 'UTF-8';
  script.setAttribute('crossorigin', '*');
  document.head.appendChild(script);

  initialized = true;
}
